import { Sparkles, Users, BookOpen } from "lucide-react"; // Added icon imports
import NewsletterSignup from "@/components/ui/NewsletterSignup";

const OmOss = () => {
  // Removed outer div and Navbar, handled by layout
  return (
    <>
      <section className="flex-grow"> {/* Removed min-h-screen and flex-col */}
        {/* Header med bakgrundsbild */}
        <div className="relative h-[500px] bg-cover bg-center" style={{ backgroundImage: 'url("/images/header-family-02.webp")' }}>
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <div className="container mx-auto h-full flex items-center justify-center relative z-10 px-4">
            <div className="text-center">
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
                Vi är Demenshjältar
              </h1>
              <p className="text-xl md:text-2xl text-white max-w-2xl mx-auto">
                För dig som står mitt i det – vi är här för att du inte ska vara ensam.
              </p>
            </div>
          </div>
        </div>

        {/* Block 1 - Full width bakgrund */}
        <div className="w-full bg-minnestig-beige mb-16">
          <div className="container mx-auto px-4 py-16">
            <div className="max-w-3xl">
              <p className="text-lg text-gray-700 mb-8">
                Vi vet hur det känns när en älskad förändras. När minnet sviktar, personligheten får sprickor och vardagen går sönder i det små. Vi har själva stått där – och vi bestämde oss för att ingen annan ska behöva gå igenom det ensam.
              </p>
              
              <h3 className="text-2xl font-semibold mb-6">Vi finns för att:</h3>
              <div className="space-y-6">
                <div className="flex items-center">
                  {/* Icon 1 */}
                  <div className="mr-4 flex-shrink-0 rounded-full bg-minnestig-lavender/30 w-12 h-12 flex items-center justify-center">
                    <Sparkles className="text-minnestig-purple" size={24} />
                  </div>
                  <p className="text-xl">Göra vardagen enklare för anhöriga, drabbade och vårdpersonal</p>
                </div>
                <div className="flex items-center">
                  {/* Icon 2 */}
                  <div className="mr-4 flex-shrink-0 rounded-full bg-minnestig-lavender/30 w-12 h-12 flex items-center justify-center"> {/* Changed background */}
                    <Users className="text-minnestig-purple" size={24} />
                  </div>
                  <p className="text-xl">Bryta ensamheten</p>
                </div>
                <div className="flex items-center">
                  {/* Icon 3 */}
                  <div className="mr-4 flex-shrink-0 rounded-full bg-minnestig-lavender/30 w-12 h-12 flex items-center justify-center">
                    <BookOpen className="text-minnestig-purple" size={24} />
                  </div>
                  <p className="text-xl">Tillgängliggöra kunskap på ett sätt som är enkelt att förstå</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4">
          {/* Block 2 */}
          <div className="mb-16">
             <h2 className="text-3xl font-bold text-minnestig-teal mb-8">Hitta stödet som passar dig</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8"> {/* Restored grid columns */}
              {/* Kort 2 (Now first) */}
              <div className="bg-white rounded-2xl shadow-sm overflow-hidden"> {/* Removed hover classes */}
                <div className="relative h-60">
                  <img 
                    src="/images/community-02.webp" 
                    alt="Community" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-semibold text-minnestig-teal mb-3">
                    Söker du någon som förstår?
                  </h3>
                  <p className="text-gray-700 mb-6">
                    I vårt community möter du andra i liknande situation. Dela erfarenheter och få stöd av människor som förstår.
                  </p>
                  <a href="/community" className="inline-flex items-center text-minnestig-purple hover:text-minnestig-teal">
                    <span className="mr-2">Upptäck vårt community</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                </div>
              </div>

              {/* Kort 3 (Now second) */}
              <div className="bg-white rounded-2xl shadow-sm overflow-hidden"> {/* Removed hover classes */}
                <div className="relative h-60">
                  <img 
                    src="/images/kampanj-ungadrabbde.webp" 
                    alt="Kampanj unga drabbade" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-semibold text-minnestig-teal mb-3">
                    Vill du vara med och påverka?
                  </h3>
                  <p className="text-gray-700 mb-6">
                    Ta del av vår kampanjer, sprid budskapet och kom med förslag på hur vi kan skapa ännu mer impact.
                  </p>
                  <a href="/kunskapsbank" className="inline-flex items-center text-minnestig-purple hover:text-minnestig-teal">
                    <span className="mr-2">Utforska kampanjer</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                </div>
              </div>

              {/* Kort 1 (Now last) */}
              <div className="bg-white rounded-2xl shadow-sm overflow-hidden"> {/* Removed hover classes */}
                <div className="relative h-60 bg-[#F8F2FF]"> {/* Added background color */}
                  <img
                    src="/images/minnestig/mobile-checklist-preview-with-frame.png" /* Updated image src */
                    alt="MinneStig appen"
                    className="w-full h-full object-contain p-4" /* Changed to object-contain and added padding */
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-semibold text-minnestig-teal mb-3">
                    Hur förbereder du dig som anhörig?
                  </h3>
                  <p className="text-gray-700 mb-6">
                    Vi utvecklar just nu MinneStig, appen som ska hjälpa dig som anhörig genom resan.
                  </p>
                  <a href="#newsletter-signup" className="inline-flex items-center text-minnestig-purple hover:text-minnestig-teal">
                    <span className="mr-2">Få uppdateringar om lansering</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Block 3 */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-minnestig-teal mb-8">Teamet bakom</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Ellen */}
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <img src="/images/team/ellen-stig-02.webp" alt="Ellen" className="w-full aspect-square object-cover rounded-lg mb-4" />
                <h3 className="text-xl font-semibold mb-2">Ellen – Grundare & affärsutvecklare</h3>
                <p className="text-gray-700 mb-4">
                  Anhörig till pappa Stig som har begynnande frontallobsdemens. Med bakgrund som affärsutvecklare kombinerar Ellen hjärta och strategi för att skapa verktyg som verkligen gör skillnad.
                </p>
                <p className="text-gray-600 italic">"Jag startade Demenshjältar för att jag själv saknade stödet jag hade behövt."</p>
              </div>

              {/* Aroshine */}
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <img src="/images/team/aroshine-01.webp" alt="Aroshine" className="w-full aspect-square object-cover rounded-lg mb-4" />
                <h3 className="text-xl font-semibold mb-2">Aroshine – Grundare & UX-designer</h3>
                <p className="text-gray-700 mb-4">
                  Har arbetat med produkter på doktor.se, Spotify och Avanza. Tidigare jobbat tre år på demensboende och brinner för att göra teknik mänsklig.
                </p>
                <p className="text-gray-600 italic">"Jag vet hur mycket ett varmt bemötande betyder. Nu vill jag bygga det digitalt."</p>
              </div>

              {/* Caroline */}
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <img src="/images/team/caroline-freddy-02.webp" alt="Caroline" className="w-full aspect-square object-cover rounded-lg mb-4" />
                <h3 className="text-xl font-semibold mb-2">Caroline – Anhörigröst & förändringskraft</h3>
                <p className="text-gray-700 mb-4">
                  Fru till Fredrik som fick Alzheimer vid 54. Caroline är vårt rivjärn och når ut där det gör skillnad – från SVT till EU-kommissionen. Hon har ett unikt nätverk inom vården och skakar om där det behövs.
                </p>
                <p className="text-gray-600 italic">"Jag tänker inte vara tyst. Vi måste prata mer om yngre med Alzheimer."</p>
              </div>

              {/* Jessica */}
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <img src="/images/team/jessica-daniel.webp" alt="Jessica" className="w-full aspect-square object-cover rounded-lg mb-4" />
                <h3 className="text-xl font-semibold mb-2">Jessica – Röst för drabbade och innehållsskapare</h3>
                <p className="text-gray-700 mb-4">
                  Fick Alzheimer vid 54 års ålder. Skriver texter som berör, belyser och skapar förståelse. En röst inifrån som berikar hela Demenshjältars plattform.
                </p>
                <p className="text-gray-600 italic">"Det här är mitt sätt att vara med i kampen – och bidra med hopp."</p>
              </div>

              {/* Piotr */}
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <img src="/images/team/piotr-cto-netoventures.webp" alt="Piotr" className="w-full aspect-square object-cover rounded-lg mb-4" />
                <h3 className="text-xl font-semibold mb-2">Piotr – Teknisk chef</h3>
                <p className="text-gray-700 mb-4">
                  Bygger plattformen så att allting bara funkar. Teknisk ledare med hjärta för att förverkliga mänskliga behov digitalt.
                </p>
                <p className="text-gray-600 italic">"Min roll är att skapa trygg teknik bakom kulisserna."</p>
              </div>
            </div>
          </div>
        </div>

        {/* Block 4 - Våra vänner med full bredd bakgrund */}
        <section className="py-16 bg-minnestig-beige">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-minnestig-teal mb-12">
              Våra vänner
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
              <img src="/images/logos/alzheimerfonden_logo.png" alt="Alzheimerfonden" className="h-16 object-contain" />
              <img src="/images/logos/alzheimers-life-logo.png" alt="Alzheimer Life" className="h-16 object-contain" />
              <img src="/images/logos/demensforbundet-logo.png" alt="Demensförbundet" className="h-16 object-contain" />
              <img src="/images/logos/demenscentrum-logo-v-300.png" alt="Demenscentrum" className="h-16 object-contain" />
              <img src="/images/logos/ytan-logo.png" alt="YTAN för unga" className="h-16 object-contain" />
            </div>
          </div>
        </section>

        {/* Block 5 - Partnerskap Alzheimer Life */}
        <section className="py-16 bg-minnestig-beige">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center gap-12">
              <div className="md:w-1/2">
                <h2 className="text-3xl font-bold text-minnestig-teal mb-6">
                  I partnerskap med Alzheimer Life
                </h2>
                <p className="text-lg text-gray-700 mb-6">
                  Alzheimer Life står på patienternas sida. Med över 15 000 prenumeranter lyfter de varje vecka berättelser från drabbade och anhöriga, granskar vårdsystemet, rapporterar om ny forskning och bromsande läkemedel, och driver opinion för en mer jämlik och värdig vård för personer med Alzheimers och andra kognitiva sjukdomar.
                </p>
                <a 
                  href="https://alzheimerlife.se/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-minnestig-purple hover:text-minnestig-teal font-medium"
                >
                  <span className="mr-2">Besök</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              <div className="md:w-1/2 flex justify-center">
                <img 
                  src="/images/logos/alzheimers-life-logo.png" 
                  alt="Alzheimer Life Logo" 
                  className="w-full max-w-xs object-contain" 
                />
              </div>
            </div>
          </div>
        </section>
      </section>
      
      <div id="newsletter-signup">
        <NewsletterSignup />
      </div>
      {/* Removed Footer, handled by layout */}
    </>
  );
};

export default OmOss;
